import { Injectable } from '@angular/core';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { Observable } from 'rxjs';

@Injectable()
export class ShiftTimelineService {
  @WilsonState<boolean>(false)
  private forceRerendering!: boolean;
  public forceRerendering$!: Observable<boolean>;

  forceGanttChartRerender() {
    this.forceRerendering = true;
    setTimeout(() => {
      this.forceRerendering = false;
    }, 200);
  }
}
